import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as ClassicVirtualAnchoredDelayActionMetadataKeys from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/constants/ClassicVirtualAnchoredDelayActionMetadataKeys';
export default class ClassicVirtualAnchoredDelayActionMetadata extends Record({
  [ClassicVirtualAnchoredDelayActionMetadataKeys.ACTION_TYPE]: ActionTypes.CLASSIC_VIRTUAL_ANCHORED_DELAY,
  [ClassicVirtualAnchoredDelayActionMetadataKeys.RECUR_ANNUALLY]: false,
  [ClassicVirtualAnchoredDelayActionMetadataKeys.STATIC_DATE_ANCHOR]: null,
  [ClassicVirtualAnchoredDelayActionMetadataKeys.CONTACT_PROPERTY_ANCHOR]: null
}, 'ClassicVirtualAnchoredDelayActionMetadata') {}